import { render } from "./MainCurrent.vue?vue&type=template&id=7f49ca2c"
import script from "./MainCurrent.vue?vue&type=script&lang=js"
export * from "./MainCurrent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__